<template>
  <div class="SubPage__container">
    <PageHeader />
    <div class="SubPage__contentGrid SubPage__firstGrid">
      <Breadcrumbs :crumbs="crumbs" />
      <div class="SubPage__header columns is-mobile">
        <div class="column">
          <h1 class="SubPage__title">Kontakt</h1>
        </div>
      </div>
      <div class="columns is-gapless">
        <div class="column is-two-thirds">
          <img
            src="https://picsum.photos/840/257"
            style="display: block; object-fit: cover; height: 100%;"
          />
        </div>
        <div class="column is-one-third">
          <SalesContainer :config="salesContainerConfig" />
        </div>
      </div>
    </div>
    <div class="SubPage__contentGrid">
      <h2 class="SubPage__subHeading">Ansprechpartner</h2>
      <div
        id="karriereData"
        style="display: none;"
        data-config='{
          "contact":{
            "contacts":[
              {
                "type":"0",
                "firstname": "",
                "lastname": "",
                "position": "",
                "company":"WIKA USA",
                "address":"1000 Wiegand Boulevard\nLawrenceville, GA 30043",
                "departments": [],
                "image": "",
                "phone": "+49 9372 1322973",
                "fax": "",
                "email": "heinz.misskam@wika.com",
                "website": "www.wika.us"
              },
              {
                "type": "0",
                "firstname": "Michael",
                "lastname": "Kreuzberger",
                "position": "Process Instrumentation",
                "departments": ["Sales External"],
                "image": "https://picsum.photos/110/180?random=1",
                "phone": "+49 9372 132-2958",
                "fax": "+49 9372 132-8002958",
                "email": "michael.kreuzberger@wika.com"
              }
            ]}
          }'
      ></div>
      <div
        id="qualitatData"
        style="display: none;"
        data-config='{
          "group":{
            "country":"",
            "language":"EN",
            "mainSalesContact":"true",
            "useFilter": true,
            "groups":[
              {
                "id": 12345,
                "name": "Subsidiary",
                "contacts":[
                  {
                    "type":"1",
                    "company":"WIKA USA 1",
                    "address":"1000 Wiegand Boulevard\nLawrenceville, GA 30043",
                    "website":"www.wika.us",
                    "phone":"1-888-945-2872",
                    "fax":"1-770-338-5118",
                    "email":"info@wika.com"
                  },
                  {
                    "type":"1",
                    "company":"WIKA USA 2",
                    "address":"1000 Wiegand Boulevard\nLawrenceville, GA 30043",
                    "website":"www.wika.us",
                    "phone":"1-888-945-2872",
                    "fax":"1-770-338-5118",
                    "email":"info@wika.com"
                  }
                ]
              },
              {
                "id": 56789,
                "name": "Bananas",
                "contacts":[
                  {
                    "type":"1",
                    "company":"WIKA USA 3",
                    "address":"1000 Wiegand Boulevard\nLawrenceville, GA 30043",
                    "website":"www.wika.us",
                    "phone":"1-888-945-2872",
                    "fax":"1-770-338-5118",
                    "email":"info@wika.com"
                  },
                  {
                    "type":"1",
                    "company":"WIKA USA 4",
                    "address":"1000 Wiegand Boulevard\nLawrenceville, GA 30043",
                    "website":"www.wika.us",
                    "phone":"1-888-945-2872",
                    "fax":"1-770-338-5118",
                    "email":"info@wika.com"
                  }
                ]
              }
            ]
          }
        }'
      ></div>
      <div
        id="secondSelect"
        style="display: none;"
        data-config='{
          "group":{
            "country":"",
            "language":"EN",
            "mainSalesContact":"true",
            "useFilter": false,
            "splitByGroups": true,
            "groups":[
              {
                "id": 26587,
                "name": "Gorilla",
                "contacts":[
                  {
                    "type":"1",
                    "company":"WIKA USA 1",
                    "address":"1000 Wiegand Boulevard\nLawrenceville, GA 30043",
                    "website":"www.wika.us",
                    "phone":"1-888-945-2872",
                    "fax":"1-770-338-5118",
                    "email":"info@wika.com"
                  },
                  {
                    "type":"1",
                    "company":"WIKA USA 2",
                    "address":"1000 Wiegand Boulevard\nLawrenceville, GA 30043",
                    "website":"www.wika.us",
                    "phone":"1-888-945-2872",
                    "fax":"1-770-338-5118",
                    "email":"info@wika.com"
                  }
                ]
              },
              {
                "id": 86723,
                "name": "Monkey",
                "contacts":[
                  {
                    "type":"1",
                    "company":"WIKA USA 3",
                    "address":"1000 Wiegand Boulevard\nLawrenceville, GA 30043",
                    "website":"www.wika.us",
                    "phone":"1-888-945-2872",
                    "fax":"1-770-338-5118",
                    "email":"info@wika.com"
                  },
                  {
                    "type":"1",
                    "company":"WIKA USA 4",
                    "address":"1000 Wiegand Boulevard\nLawrenceville, GA 30043",
                    "website":"www.wika.us",
                    "phone":"1-888-945-2872",
                    "fax":"1-770-338-5118",
                    "email":"info@wika.com"
                  }
                ]
              }
            ]
          }
        }'
      ></div>
      <div
        id="umweltData"
        style="display: none;"
        data-config='{
          "contact":{
            "contacts":[
              {
                "type":"0",
                "firstname": "",
                "lastname": "",
                "position": "",
                "company":"WIKA USA",
                "address":"1000 Wiegand Boulevard\nLawrenceville, GA 30043",
                "departments": [],
                "image": "",
                "phone": "+49 9372 1322973",
                "fax": "",
                "email": "heinz.misskam@wika.com",
                "website": "www.wika.us"
              },
              {
                "type": "0",
                "firstname": "Michael",
                "lastname": "Kreuzberger",
                "position": "Process Instrumentation",
                "departments": ["Sales External"],
                "image": "https://picsum.photos/110/180?random=2",
                "phone": "+49 9372 132-2958",
                "fax": "+49 9372 132-8002958",
                "email": "michael.kreuzberger@wika.com"
              }
            ]}
          }'
      ></div>
      <div
        id="vertriebData"
        style="display: none;"
        data-config='{
          "zip": {
            "placeholderText":"Postleitzahl eingeben",
            "errorMessage":"Bitte geben Sie eine gültige Postleitzahl ein.",
            "resultMessage":"Ihr Ansprechpartner für das Postleitzahlengebiet {zip} ist:",
            "noResultsMessage":"Keine Kontakte gefunden.",
            "regex":"^[0-9]{5}$",
            "country":"",
            "language":"DE",
            "mainSalesContact":"true",
            "ranges":[
              {
                "from": "00000",
                "to": "09999",
                "departments":["Sales External", "Sales Internal"],
                "contacts":[
                  {
                    "type":"0",
                    "firstname":"Mareike",
                    "lastname":"Kohlmann",
                    "position":"Industrial Instrumentation",
                    "departments":["Sales External"],
                    "image":"https://picsum.photos/110/180?random=3",
                    "phone":"+49 9372 132-2689",
                    "fax":"+49 9372 132-8002689",
                    "email":"Mareike.Kohlmann@wika.com"
                  },
                  {
                    "type":"0",
                    "firstname":"Mareike",
                    "lastname":"Kohlmann",
                    "position":"Industrial Instrumentation",
                    "departments":["Sales Internal"],
                    "image":"https://picsum.photos/110/180?random=3",
                    "phone":"+49 9372 132-2689",
                    "fax":"+49 9372 132-8002689",
                    "email":"Mareike.Kohlmann@wika.com"
                  },
                  {
                    "type":"0",
                    "firstname":"Mareike",
                    "lastname":"Kohlmann",
                    "position":"Industrial Instrumentation",
                    "departments":["Sales Internal"],
                    "image":"https://picsum.photos/110/180?random=3",
                    "phone":"+49 9372 132-2689",
                    "fax":"+49 9372 132-8002689",
                    "email":"Mareike.Kohlmann@wika.com"
                  }
                ]
              },
              {
                "from": "10000",
                "to": "19999",
                "departments":[],
                "contacts":[
                  {
                    "type":"0",
                    "firstname":"Bobby",
                    "lastname":"Davro",
                    "position":"Industrial Instrumentation",
                    "departments":["Sales External"],
                    "image":"https://picsum.photos/110/180?random=3",
                    "phone":"+49 9372 132-2689",
                    "fax":"+49 9372 132-8002689",
                    "email":"Mareike.Kohlmann@wika.com"
                  },
                  {
                    "type":"0",
                    "firstname":"Bobby",
                    "lastname":"Ball",
                    "position":"Industrial Instrumentation",
                    "departments":["Sales Internal"],
                    "image":"https://picsum.photos/110/180?random=3",
                    "phone":"+49 9372 132-2689",
                    "fax":"+49 9372 132-8002689",
                    "email":"Mareike.Kohlmann@wika.com"
                  },
                  {
                    "type":"0",
                    "firstname":"Tommy",
                    "lastname":"Cannon",
                    "position":"Industrial Instrumentation",
                    "departments":["Sales Internal"],
                    "image":"https://picsum.photos/110/180?random=3",
                    "phone":"+49 9372 132-2689",
                    "fax":"+49 9372 132-8002689",
                    "email":"Mareike.Kohlmann@wika.com"
                  }
                ]
              }
            ]
          }
        }'
      ></div>
      <ContactList :config="listConfig" />
    </div>
    <Footer />
    <CookieDisclaimer :config="cookieDisclaimerConfig" />
  </div>
</template>

<script>
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import Footer from "../Footer/Footer";
import SalesContainer from "../SalesContainer/SalesContainer";
import PageHeader from "../PageHeader/PageHeader";
import CookieDisclaimer from "../CookieDisclaimer/CookieDisclaimer";
import ContactList from "../ContactList/ContactList";

export default {
  name: "ContactListPage",
  components: {
    Breadcrumbs,
    Footer,
    SalesContainer,
    PageHeader,
    CookieDisclaimer,
    ContactList
  },
  data() {
    return {
      cookieDisclaimerConfig: {
        text:
          "Unsere Webseite verwendet Cookies. Durch die weitere Nutzung stimmen Sie der Verwendung zu.",
        link: {
          text: "Weitere Informationen",
          url: "#"
        },
        button: {
          text: "Zustimmen",
          colour: "blue"
        }
      },
      crumbs: [
        {
          title: "Startseite",
          url: "#"
        },
        {
          title: "Kontakt",
          url: "#"
        },
        {
          title: "Ansprechpartner",
          url: "#"
        }
      ],
      salesContainerConfig: {
        title: "Vertriebskontakt",
        text: "Fragen? Finden Sie Ihren Ansprechpartner im WIKA-Vertriebsteam.",
        icon: "fas fa-user-tie",
        input: {
          placeholderText: "Postleitzahl eingeben",
          submitUrl: "contact_de_at.WIKA?cnType=1&cnEntry="
        },
        buttons: [
          {
            icon: "far fa-comments",
            text: "Jetzt chatten",
            offlineText: "Nachricht senden"
          },
          {
            icon: "fas fa-envelope",
            text: "Kontaktformular",
            linkUrl: "#"
          }
        ]
      },
      listConfig: [
        {
          title: "Qualität",
          id: "qualitatData",
          initialSelectOption: "Bitte wählen..."
        },
        {
          title: "Vertrieb",
          id: "vertriebData"
        },
        {
          title: "Second select",
          id: "secondSelect",
          initialSelectOption: "Bitte wählen..."
        },
        {
          title: "Umwelt",
          id: "umweltData"
        },
        {
          title: "Karriere",
          id: "karriereData"
        },
        {
          active: true,
          title: "WIKA Weltweit",
          id: "worldwide",
          worldwide: true,
          config: {
            currentRegion: "Europa",
            currentCountry: "Deutschland",
            regionLabel: "Kontinent",
            countryLabel: "Land"
          }
        }
      ]
    };
  }
};
</script>
